import type { SVGProps } from 'react';
export const SvgBack = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="m12.5 16.6-5.433-5.433a1.655 1.655 0 0 1 0-2.333L12.5 3.4"
		/>
	</svg>
);
